import { Button, Divider, Flex, Space, Tag, Tooltip, Typography } from 'antd'
import { Pencil, Trash2 } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import type { OrganizationRoleFull } from 'src/api/main'

const { Text } = Typography

type Props = {
  role: OrganizationRoleFull
  onEdit: (role: OrganizationRoleFull) => void
  onDelete: (role: OrganizationRoleFull) => void
  onSelectAll?: () => void
  onDeselectAll?: () => void
}

export const RoleColumnHeader = ({
  role,
  onEdit,
  onDelete,
  onSelectAll,
  onDeselectAll
}: Props) => {
  const { t } = useTranslation()
  const isAdmin = role.is_admin

  return (
    <Flex vertical style={{ width: '100%' }}>
      <Flex justify="space-between" align="center">
        <Space size={4} align="center">
          <Tooltip title={role?.name}>
            <Text strong style={{ fontSize: 14 }}>
              {role?.name}
            </Text>
          </Tooltip>
          {isAdmin ? (
            <Tooltip title={t('workspace.apps.roles.adminHasFullAccess')}>
              <Tag color="blue">{t('workspace.apps.roles.admin')}</Tag>
            </Tooltip>
          ) : null}
        </Space>
        <Space size={0}>
          <Button
            type="text"
            size="small"
            icon={<Pencil size={14} />}
            onClick={() => onEdit(role)}
            aria-label={t('workspace.apps.roles.edit')}
          />
          <Button
            type="text"
            size="small"
            danger
            icon={<Trash2 size={14} />}
            onClick={() => onDelete(role)}
            aria-label={t('delete')}
          />
        </Space>
      </Flex>

      {role?.description ? (
        <Tooltip title={role.description}>
          <Text type="secondary" style={{ fontSize: 12 }} ellipsis>
            {role.description}
          </Text>
        </Tooltip>
      ) : null}

      {!isAdmin && onSelectAll && onDeselectAll ? (
        <Space size={4} style={{ marginTop: 2 }}>
          <Button
            type="link"
            size="small"
            style={{ padding: 0, height: 'auto' }}
            onClick={onSelectAll}
          >
            {t('workspace.apps.roles.selectAll')}
          </Button>
          <Divider orientation="vertical" />
          <Button
            type="link"
            size="small"
            style={{ padding: 0, height: 'auto' }}
            onClick={onDeselectAll}
          >
            {t('workspace.apps.roles.deselectAll')}
          </Button>
        </Space>
      ) : null}
    </Flex>
  )
}
